"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var gatsby_plugin_image_1 = require("gatsby-plugin-image");

function getCMSImage(data, name, noEmitError) {
  var _a;

  var image = data.nodes.find(function (i) {
    return i.data.Name === name;
  });

  if (image) {
    var sources = (0, gatsby_plugin_image_1.getImage)(image.data.Image.localFiles[0]);
    var url = (_a = image.data.Image.localFiles[0].childImageSharp.gatsbyImageData.images.fallback) === null || _a === void 0 ? void 0 : _a.src;
    var alt = image === null || image === void 0 ? void 0 : image.data.Text;
    if (sources && alt) return {
      sources: sources,
      alt: alt,
      url: url
    };
  }

  if (noEmitError) return undefined;
  throw new Error("Image ".concat(name, " not found in ") + "Airtable. Does the query include the " + "right tables, and does one of those " + "tables include a section called ".concat(name, "?."));
}

exports.default = getCMSImage;